import { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import CookieConsent from './components/common/cookieconsent';
import GrowBusinessPage from './pages/grow-business';
import ReschedulePage from '@/pages/grow-business/reschedule/[id]';
import RescheduledPage from '@/pages/grow-business/rescheduled/[id]';
import CancelPage from '@/pages/grow-business/cancel/[id]';
import ContactPage from '@/pages/contact';
import PrivacyPolicy from '@/pages/privacy-policy';

import App from '@/App';


// Import all .tsx files under the locations directory
const locationModules = import.meta.glob<{ default: React.ComponentType<any> }>([
  './locations/**/*.tsx',
]);

// Generate location routes
const locationRoutes = Object.entries(locationModules).map(([modulePath, moduleLoader]) => {
  let routePath = modulePath
    .replace('./locations', '') // Adjust base path for locations
    .replace(/\.tsx$/, '')
    .replace(/\/index$/, '')
    .toLowerCase();

  const Component = lazy(moduleLoader);
  return { path: routePath, Component };
});




// const modules = import.meta.glob([
const modules = import.meta.glob<{
  default: React.ComponentType<any>;
}>([
  './mobile-notary/**/*.tsx',
  './resources/**/*.tsx',
  './events/**/*.tsx',
  './customer-stories/**/*.tsx',
  './community/**/*.tsx',
  './demo/**/*.tsx',
  './solutions/**/*.tsx',
  './blog/**/*.tsx',
  './legal/**/*.tsx',
  './marketing/**/*.tsx',
]);

// Generate route objects from the modules
const routes = Object.keys(modules).map((modulePath) => {
  // Get the route path from the module path
  let routePath = modulePath
    .replace('./', '/') // Remove './' at the beginning
    .replace(/\.tsx$/, '') // Remove file extension
    .replace(/\/index$/, '') // Remove '/index' at the end
    .toLowerCase(); // Optional: convert to lowercase

  // Replace [param] with :param for dynamic routes
  routePath = routePath.replace(/\[(.+?)\]/g, ':$1');

  // Lazy load the component
  // const Component = lazy(modules[modulePath] as () => Promise<{ default: React.ComponentType<any> }>);
  const Component = lazy(() => modules[modulePath]());

  return {
    path: routePath,
    Component,
  };
});

const MainRouter = () => (
  <Router>
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        {/* If you have specific routes that need to be defined first, add them here */}
        <Route path="/" element={<App />} />
        <Route path="/grow-business" element={<GrowBusinessPage />} />
        <Route path="/grow-business/reschedule/:id" element={<ReschedulePage />} />
        <Route path="/grow-business/rescheduled/:id" element={<RescheduledPage />} />
        <Route path="/grow-business/cancel/:id" element={<CancelPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        {/* <Route path="/immigration" element={<ImmigrationLandingPage />} />
        <Route path="/resources" element={<ResourceLibrary />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/mobile" element={<Mobile />} />
        <Route path="/ralphbrooks" element={<ProfilePage />} />
        <Route path="/frisco" element={<FriscoPage />} />
        <Route path="/locations" element={<LocationsPage />} /> */}

        {/* Render locationRoutes */}
        {locationRoutes.map(({ path, Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}

        {/* The following needs to move over to mobile when mobile page is completed */}
        {/* <Route path="/mobile-notary/frisco" element={<ProfilePage />} />   */}
        {routes.map(({ path, Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
      </Routes>
    </Suspense>
    <CookieConsent />
  </Router>
);

export default MainRouter;
